"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ForecastChangeWindowDTO converter.
 *
 * @author OPt
 */


var ForecastChangeWindowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastChangeWindowDTOConverter, _DataObjectConverter_);

  function ForecastChangeWindowDTOConverter() {
    _classCallCheck(this, ForecastChangeWindowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeWindowDTOConverter).apply(this, arguments));
  }

  return ForecastChangeWindowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastChangeWindowDTOConverter = ForecastChangeWindowDTOConverter;